import React from 'react';
import { get } from 'lodash';
import { format } from 'date-fns';
import { getLabel } from '../Language/labels';

export const OverviewTableRow = ({ entry, showEntry, entryImage, deleteEntry }) => {
  
  const { category, id } = entry;

  const closingDateString = get(category, 'data.genre.data.competition.data.end.date', '0');
  const closingDate = new Date(closingDateString);

  return (
    <>
      <div className='overview-row'>
        <span className='small-heading'>{getLabel('overviewLabelCompetition')}</span>
        <span className='overview-row-value'>{get(category, 'data.genre.data.competition.data.name', '&nbsp;')}</span>
      </div>
      <div className='overview-row'>
        <span className='small-heading'>{getLabel('overviewLabelCategory')}</span>
        <span className='overview-row-value'>{get(category, 'data.name')}</span>
      </div>
      <div className='overview-row'>
        <span className='small-heading'>{getLabel('overviewLabelDate')}</span>
        <span className='overview-row-value'>{format(closingDate, 'dd / MM / yyyy')}</span>
      </div>
      <div className='overview-row'>
        <span className='small-heading'>{getLabel('overviewLabelStatus')}</span>
        <span className='overview-row-value'>{getLabel('entrySubmittedStatus')}</span>
      </div>
      <div className='overview-row'>
        <span className='small-heading'>{getLabel('overviewLabelId')}</span>
        <span className='overview-row-value'>{id}</span>
      </div>
      <div className='overview-row last-column' onClick={() => showEntry(entry, entryImage)}>
        <span className='small-heading'>{getLabel('overviewActions')}</span>
        <span className='overview-row-value overview-link'>{getLabel('overviewViewEntry')}</span>
      </div>
      {/* <div className='overview-row last-column' onClick={() => deleteEntry(entry.id)}>
        <span className='small-heading'>{getLabel('overviewActions')}</span>
        <span className='overview-row-value overview-link'>delete entry</span>
      </div> */}
    </>
  )
}